import React from 'react'
import { BtSelect } from '@linqpal/components/src/ui'
import { useTranslation } from 'react-i18next'
import { ROLES } from '@linqpal/models/src/dictionaries'

const options = Object.values(ROLES)

const Role = ({ model, value }) => {
  const { t } = useTranslation('global')
  const handleSelect = (val) => {
    model.setValue(val)
  }
  return (
    <BtSelect
      size="large"
      options={options}
      testID="RoleInput"
      label={t('ProjectForm.role-label')}
      value={value}
      placeholder={t('ProjectForm.role-placeholder')}
      onChange={handleSelect}
      primitiveArray
    />
  )
}

export default {
  identifier: 'role',
  title: 'Role on this project',
  component: Role,
  shouldProcessAnswer: true,
  optional: true,
}
